export default __webpack_public_path__ + "static/media/nextArrow.ff2810d9.svg";